<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title"><a id="contents"></a><a id="page_5">Contents</a></h1><a id="page_5">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="20%"/>
<col width="80%"/>
</colgroup>
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc-para-top"><a href="#/xhtml/05_Acknowledgements"><b>Acknowledgements</b></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc-para-top"><a href="#/xhtml/06_Introduction"><b>Introduction</b></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><a href="#/xhtml/07_Chapter01"><b>Chapter 1</b></a></p></td>
<td align="left" valign="top"><p class="toc-para-top"><a href="#/xhtml/07_Chapter01">A Victorian Shooting: The Murder of George Firth (1851)</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample"><b>Chapter 2</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">The Shocking Death of the Bearded Lady (William Ratcliffe) (1883)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><b>Chapter 3</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Death of a Draper: The Mysterious Case of Florence Hargreaves (1926)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><b>Chapter 4</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">The Murder of a Barnsley Gangster: The Death of Mark Scott (1931)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><b>Chapter 5</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Murder of a Musician: The Death of Lily Stephenson (1962)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><b>Chapter 6</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">A Beast at Large: The Murder of Anne Dunwell (1964)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><b>Chapter 7</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">The Most Wanted Man in Sheffield: The Hunt for the Killer of John Wortley (1975)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample"><b>Chapter 8</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">The Violent Murder of Barbara Young (1977)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample"><b>Chapter 9</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">The Tragic Murder of an Unidentified Baby Girl (1981)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample"><b>Chapter 10</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">The Murder of the Cheerful Jamaican: The Calculated Murder of Terivia Cameron (1982)</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample"><b>Chapter 11</b></span></p></td>
<td align="left" valign="top"><p class="toc-para-top"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Out of the Cold in South Yorkshire</span></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?9a3967f4